export default "__VITE_ASSET__2b7ea520__"